"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var json_rpc_dispatcher_1 = require("@dealroadshow/json-rpc-dispatcher");
var ProtocolHelper_1 = __importDefault(require("./ProtocolHelper"));
var Subscription_1 = __importDefault(require("./Subscription"));
var SockJsAdapter_1 = __importDefault(require("./JsonRpcDispatcher/SockJsAdapter"));
var api_1 = require("@opentelemetry/api");
var instrumentation_1 = require("./instrumentation");
var tracer = api_1.trace.getTracer(instrumentation_1.OTEL_TRACER_NAME);
/**
 * Socket client that can be used to perform subscriptions and event listening
 */
var Client = /** @class */ (function () {
    function Client(rpc) {
        var _this = this;
        this.rpc = rpc;
        this.subscriptions = new Map();
        /**
         * Subscribe to socket event.
         * socket.routingKey header will be generated on back-end using next algorithm:
         * ```javascript
         * JSON.stringify({
         *  method: request.method, payload: request.params.payload
         * })
         * ```
         */
        this.subscribe = function (request) { return __awaiter(_this, void 0, void 0, function () {
            var subscription;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, tracer.startActiveSpan((0, instrumentation_1.withPrefix)('Client.subscribe'), function (subscribeSpan) { return __awaiter(_this, void 0, void 0, function () {
                            var subscribeRequest_1, response, routingKey_1, subscription_1, subscription_2;
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, , 4, 5]);
                                        subscribeRequest_1 = ProtocolHelper_1.default.toSubscribeRequest((0, json_rpc_dispatcher_1.parse)(request));
                                        subscribeSpan.addEvent('sending-subscribe-request');
                                        return [4 /*yield*/, this.rpc.call(subscribeRequest_1)];
                                    case 1:
                                        response = _a.sent();
                                        if (!(response instanceof json_rpc_dispatcher_1.RpcError)) return [3 /*break*/, 3];
                                        return [4 /*yield*/, Promise.reject(response)];
                                    case 2: return [2 /*return*/, _a.sent()];
                                    case 3:
                                        routingKey_1 = ProtocolHelper_1.default.getRoutingKey(response);
                                        subscribeSpan.addEvent('subscribe-response-received');
                                        if (this.subscriptions.has(routingKey_1)) {
                                            subscribeSpan.addEvent('subscription-already-exists');
                                            subscription_1 = this.subscriptions.get(routingKey_1).subscription;
                                            return [2 /*return*/, subscription_1];
                                        }
                                        subscription_2 = new Subscription_1.default(routingKey_1, function () {
                                            return tracer.startActiveSpan((0, instrumentation_1.withPrefix)('Client.unsubscribe'), function (unsubscribeSpan) { return __awaiter(_this, void 0, void 0, function () {
                                                var unsubscribe;
                                                return __generator(this, function (_a) {
                                                    this.subscriptions.delete(routingKey_1);
                                                    unsubscribe = this.rpc.call(ProtocolHelper_1.default.toUnsubscribeRequest(subscribeRequest_1));
                                                    unsubscribeSpan.end();
                                                    return [2 /*return*/, unsubscribe];
                                                });
                                            }); });
                                        });
                                        api_1.propagation.inject(api_1.context.active(), subscription_2);
                                        this.subscriptions.set(routingKey_1, {
                                            subscription: subscription_2,
                                            subscribeRequest: subscribeRequest_1,
                                        });
                                        return [2 /*return*/, subscription_2];
                                    case 4:
                                        subscribeSpan.end();
                                        return [7 /*endfinally*/];
                                    case 5: return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        subscription = _a.sent();
                        return [2 /*return*/, subscription];
                }
            });
        }); };
        this.handleMessage = function (payload) {
            var _a;
            var notification = (0, json_rpc_dispatcher_1.parse)(payload);
            var activeContext = api_1.propagation.extract(api_1.context.active(), (_a = notification.params) === null || _a === void 0 ? void 0 : _a.headers);
            return api_1.context.with(activeContext, function () { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    tracer.startActiveSpan((0, instrumentation_1.withPrefix)('Client.handleMessage'), {
                        attributes: {
                            method: notification.method,
                        },
                    }, function (span) { return __awaiter(_this, void 0, void 0, function () {
                        var routingKey, subscription;
                        return __generator(this, function (_a) {
                            routingKey = ProtocolHelper_1.default.getRoutingKey(notification);
                            subscription = (this.subscriptions.get(routingKey) || {}).subscription;
                            if (subscription && (notification instanceof json_rpc_dispatcher_1.RpcNotification)) {
                                subscription.emit(notification);
                            }
                            span.end();
                            return [2 /*return*/];
                        });
                    }); });
                    return [2 /*return*/];
                });
            }); });
        };
        this.resubscribeAll = function () {
            _this.subscriptions.forEach(function (subscription) {
                var activeContext = api_1.propagation.extract(api_1.context.active(), subscription);
                var span = tracer.startSpan((0, instrumentation_1.withPrefix)('Client.resubscribe'), {
                    attributes: {
                        routingKey: subscription.subscription.getRoutingKey(),
                    },
                }, activeContext);
                // Set the created span as active in the deserialized context.
                api_1.trace.setSpan(activeContext, span);
                return _this.resubscribe(subscription);
            });
        };
        this.getConnection = function () { return _this.connection; };
        var rpcAdapter = this.rpc.getAdapter();
        if (!(rpcAdapter instanceof SockJsAdapter_1.default)) {
            throw new TypeError('JsonRpcDispatcher must use SockJsAdapter in order to work with socket. Please make sure you\'re passing the right dispatcher to constructor');
        }
        /**
         * @type {Connection}
         */
        this.connection = rpcAdapter.getConnection();
        this.connection.onMessage(this.handleMessage);
        this.connection.onConnect(this.resubscribeAll);
    }
    Client.prototype.resubscribe = function (subscription) {
        return this.rpc.call(subscription.subscribeRequest);
    };
    return Client;
}());
exports.default = Client;
//# sourceMappingURL=Client.js.map